import { useEffect } from "react";
import Lenis from "lenis";
import { NavigationHeader } from "@/components/site/NavigationHeader";
import { KineticHero } from "@/components/site/KineticHero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { ManifestoChapters } from "@/components/site/ManifestoChapters";
import { ChantierGallery } from "@/components/site/ChantierGallery";
import { TrustMatrix } from "@/components/site/TrustMatrix";
import { ZoneMap } from "@/components/site/ZoneMap";
import { ContactDirect } from "@/components/site/ContactDirect";
import { AtelierFooter } from "@/components/site/AtelierFooter";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="home-page">
      <NavigationHeader />
      <KineticHero />
      <EditorialMarquee />
      <ManifestoChapters />
      <ChantierGallery />
      <TrustMatrix />
      <ZoneMap />
      <ContactDirect />
      <AtelierFooter />
    </main>
  );
}
